import siteMap from "../site-map";
import Overlay from "../overlay";

const ANIMATION_DURATION = 500;

export default function siteMapOverlay(elementIds) {
    const elements = findElements(elementIds);

    const overlay = new Overlay(elements.overlay);
    overlay.addToggleButton(elements.button);

    siteMap(elements.map, {
        hoverAnimations: {
            "Halle1":  "hoverHalle1",
            "Halle3":  "hoverHalle3",
            "Halle4":  "hoverHalle4",
            "Foyer":   "hoverFoyer",
            "Foyer_1": "Foyer_1|CINEMA_4D_Main|Layer0",
            "Foyer_2": "hoverGarderobe",
            "Dampfgebläsehaus": "hoverDgb",
        },
        hoverLinks: {
            "Halle1":  "/halle-1/",
            "Halle3":  "/halle-3/",
            "Halle4":  "/halle-4/",
            "Foyer":   "/foyer/",
            "Foyer_1": "/foyer/?sweep=09304d637af14d05ab84c0ce0b72c581:-5.79,-60.00",
            "Foyer_2": "/foyer/?sweep=3371b71c8a4d49718ecdabb885fec5aa:-0.84,-9.70",
            "Dampfgebläsehaus": "/dampfgeblaesehaus/",
        }
    }).then(map => {
        map.paused = true;

        overlay.onshow = () => {
            map.paused = false;
        };

        overlay.onhide = () => {
            map.paused = true;
        };
    });
}

function findElements(object) {
    const out = {};

    for (const [key, value] of Object.entries(object)) {
        if (typeof value === "string") {
            out[key] = document.getElementById(value);
        } else if (typeof value === "object") {
            out[key] = findElements(value);
        }
    }

    return out;
}
